export default "__VITE_ASSET__BjvxQlOu__"